import React from 'react';
import { IOption } from '../../../../../panda';

import { InputRadio } from '../../../../Input';

import './index.css';

interface IProps {
  name: string;
  setFn: (value: any) => void;
  title?: string;
  options: IOption[];
  value: string | number;
}

const BaseInputRadio = ({ name, setFn, title, value, options }: IProps) => (
  <InputRadio
    input={{
      value,
      name,
      onChange: setFn,
    }}
    meta={{}}
    isReverse
    isSmall
    options={options}
    title={title}
  />
);

export default BaseInputRadio;
